import { RANGE_FORCASTING_DATA, GET_SIMULATION, GET_FMU, GET_FCMT } from './actionTypes';

export const showRangeForcastingData = (config) => {
    return {
        type: RANGE_FORCASTING_DATA,
        config
    };
}

export const getSimultionDetails = (data) => {
    return ({
        type: GET_SIMULATION,
        payload: data,
    })
}

export const getfMUDetails = (data) => {
    return ({
        type: GET_FMU,
        payload: data,
    })
}

export const getSimultionFCMT = (data) => {
    return ({
        type: GET_FCMT,
        payload: data,
    })
}